import clsx from 'clsx'
import React from 'react'
import NextImage from 'next/image'

import { Text } from '@wartek-id/text'

import { humanizeNumber } from 'utils/number'

interface IPelatihanMandiriBadgesProps {
  total: number
}
const PelatihanMandiriBadges = ({ total }: IPelatihanMandiriBadgesProps) => {
  const MAX_DISPLAYED_BADGES = 19
  const ROW_INDEXES = [
    {
      start: 0,
      end: 7,
    },
    {
      start: 7,
      end: 13,
    },
    {
      start: 13,
      end: 19,
    },
  ]
  const humanizedDiffCount = React.useMemo(
    () =>
      humanizeNumber(total - MAX_DISPLAYED_BADGES, 0, 1000, ['', 'rb', 'jt']),
    [total]
  )

  return (
    <>
      {ROW_INDEXES.map(({ start, end }) => {
        const isLastRow = start >= 13
        const isExceededMaxItem = total > 19

        if (total <= start) {
          return null
        }

        return (
          <div
            key={`row-${start}`}
            className={clsx(isLastRow && isExceededMaxItem && 'flex')}
          >
            {Array(total)
              .slice(start, end)
              .fill(0)
              .map((_, index) => (
                <NextImage
                  data-testid="profile-pelatihan-mandiri-star-badge"
                  key={index}
                  layout="fixed"
                  src="/icon/gold-star-badge.png"
                  alt="Star Badge"
                  width="40px"
                  height="40px"
                />
              ))}

            {start >= 13 && (
              <>
                {total === 20 && (
                  <div className="w-[40px] h-[40px] flex items-center justify-center">
                    <NextImage
                      data-testid="profile-pelatihan-mandiri-star-badge"
                      layout="fixed"
                      src="/icon/gold-star-badge.png"
                      alt="Star Badge"
                      width="40px"
                      height="40px"
                    />
                  </div>
                )}

                {total > 20 && (
                  <div className="w-[40px] h-[40px] flex items-center justify-center">
                    <Text
                      data-testid="profile-pelatihan-mandiri-rest-count"
                      variant="body-sm"
                      className="!font-bold"
                    >
                      +{humanizedDiffCount}
                    </Text>
                  </div>
                )}
              </>
            )}
          </div>
        )
      })}
    </>
  )
}

export default PelatihanMandiriBadges
